import { PanelUrlStateDirective } from '../../url-state/panel-url-state.directive';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconsModule } from '../../design/icons.module';
import { InlinePanelComponent } from './inline-panel.component';

@NgModule({
  declarations: [InlinePanelComponent, PanelUrlStateDirective],
  imports: [CommonModule, IconsModule],
  exports: [InlinePanelComponent, PanelUrlStateDirective]
})
export class InlinePanelModule { }
